// Import model
import { DataviewBomKitItemResponse } from '../models/DataviewBomKitItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { BomKitItem } from '../models/BomKitItem';
import { DataView } from '../models/DataView';
import { FilterBomKitItemRequest } from '../models/FilterBomKitItemRequest';

// Import dependency serializers (for complex types)
import { BomKitItemSerializer } from './BomKitItemSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterBomKitItemRequestSerializer } from './FilterBomKitItemRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewBomKitItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewBomKitItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewBomKitItemResponse instance
   */
  static deserialize(json: string): DataviewBomKitItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewBomKitItemResponse instance
   */
  static fromObject(obj: any): DataviewBomKitItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewBomKitItemResponse');
    }


    const instance: DataviewBomKitItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        BomKitItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterBomKitItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewBomKitItemResponse instances
   */
  static deserializeArray(json: string): DataviewBomKitItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewBomKitItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewBomKitItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewBomKitItemResponse instance to a plain object
   */
  static toObject(instance: DataviewBomKitItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        BomKitItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterBomKitItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewBomKitItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewBomKitItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
